type NavigableNotification = {
  kind: string;
  title: string;
  href?: string | null;
};

const ADMIN_WORK_REVIEW = "/app/admin/programs#instructor-work-control";

export function notificationDestination(
  item: NavigableNotification,
  userRole?: string,
) {
  if (
    userRole === "admin" &&
    ["recording_submission", "session_completion"].includes(item.kind)
  ) {
    return ADMIN_WORK_REVIEW;
  }

  const legacyTeamMessage =
    item.kind === "support" &&
    ["/app", "/app/admin"].includes(item.href ?? "") &&
    /new message from kidix|kidix conversation/i.test(item.title);

  if ((item.kind === "message" || legacyTeamMessage) && userRole) {
    return `/app/${userRole}/messages`;
  }

  return item.href;
}
